import styled from "styled-components";

export const LoginContainer = styled.div`
  position: fixed;
  top: calc(var(--theme-header-height) + 50px);
  width: 60%;
  left: 20%;
  right: 20%;
  height: calc(100vh - var(--theme-header-height));

  @media (max-width: 800px) {
    top: var(--theme-header-height);
    left: 0;
    right: 0;
    width: 100%;
  }
`;

export default { LoginContainer };
